<div class="contentBlock">
  <h2 class="contentTitle" *scText="rendering.fields.heading"></h2>
  <div class="contentDescription" *scRichText="rendering.fields.content"></div>
</div>
